jQuery(document).ready(function ($) {
    var owl = $(".owl-carousel.slider").owlCarousel({
        items: 1,
        dotsContainer: '.carousel-custom-dots',
        autoplay: false,
        loop: true,
        smartSpeed: 1000
    });
    $('.owl-dot').click(function () {
        owl.trigger('to.owl.carousel', [$(this).index(), 300]);
    });
    $('.menu-transparente .navbar-toggler').on('click', function () {
        const $menu = $('.menu-transparente');
        if ($(this).hasClass('collapsed')) {
            // Si tiene la clase 'collapsed', elimina 'opened' si existe
            $menu.removeClass('opened');
        } else {
            // Si no tiene la clase 'collapsed', añade 'opened'
            $menu.addClass('opened');
        }
    });
    function updateCustomArrowOpacity(carousel, $prev, $next) {
        var carouselData = carousel.data('owl.carousel');

        // Verifica si estamos en el primer o último elemento
        if (carouselData.current() === 0) {
            $prev.css('opacity', '0.5').css('pointer-events', 'none'); // Deshabilitado
        } else {
            $prev.css('opacity', '1').css('pointer-events', 'auto'); // Habilitado
        }

        if (carouselData.current() === carouselData.maximum()) {
            $next.css('opacity', '0.5').css('pointer-events', 'none'); // Deshabilitado
        } else {
            $next.css('opacity', '1').css('pointer-events', 'auto'); // Habilitado
        }
    }

    function setupCarouselNavigation(carousel, $prev, $next) {
        $prev.click(function () {
            carousel.trigger('prev.owl.carousel');
            setTimeout(() => updateCustomArrowOpacity(carousel, $prev, $next), 50);
        });

        $next.click(function () {
            carousel.trigger('next.owl.carousel');
            setTimeout(() => updateCustomArrowOpacity(carousel, $prev, $next), 50);
        });

        updateCustomArrowOpacity(carousel, $prev, $next);
    }

    var $prev = $('.coleccion-con-carrusel').find('.prev');
    var $next = $('.coleccion-con-carrusel').find('.next');
    var collection_with_carousel = $(".owl-carousel.collection-carousel").owlCarousel({
        margin: 25,
        dots: false,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            }
        }
    });

    // Configurar la navegación para el carrusel
    if ($('.collection-carousel').length) {
        setupCarouselNavigation(collection_with_carousel, $prev, $next);
    }
    $('.color-container').hover(function () {
        var id = $(this).attr('data-variant-id')
        $('.color-container').removeClass('active')
        $(this).addClass('active')
        if (id.length > 0) {
            $('.variant-featured-image').removeClass('active')
            $('.' + id).addClass('active')
        } else {
            $('.variant-featured-image').removeClass('active')
        }
    })
    var collections_with_carousel = $('.collections-with-carousel').owlCarousel({
        margin: 25,
        dots: false,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            992: {
                items: 3
            }
        }
    });
    var $prev2 = $('.colecciones-con-carrusel').find('.prev');
    var $next2 = $('.colecciones-con-carrusel').find('.next');
    if ($('.collections-with-carousel').length) {
        setupCarouselNavigation(collections_with_carousel, $prev2, $next2);
    }

    var shop_the_look = $('.shop-the-look .owl-carousel').owlCarousel({
        margin: 25,
        dots: false,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            }
        }
    });
    var $prev3 = $('.shop-the-look').find('.prev');
    var $next3 = $('.shop-the-look').find('.next');
    if ($('.shop-the-look').length) {
        setupCarouselNavigation(shop_the_look, $prev3, $next3);
    }
    if ($('.menu-transparente').length) {
        var headerHeight = $('.menu-transparente').outerHeight();
    } else {
        var headerHeight = $('.contenedor-header').outerHeight();
    }
    var $stickyHeader = $('.carma-header-sticky');

    $(window).on('scroll', function () {
        if ($(this).scrollTop() > headerHeight) {
            $stickyHeader.slideDown('slow');
        } else {
            $stickyHeader.slideUp('fast');
        }
    });
    if ($('.imagen-producto').length) {
        $('.imagen-producto').on('load', function () {
            var alto_imagen = $(this).innerHeight();
            $('.columna-thumbnails').css('max-height', alto_imagen + 'px');
        }).each(function () {
            // Esto fuerza a disparar el evento load si la imagen ya está en caché
            if (this.complete) $(this).trigger('load');
        });
    }
    $('.thumbnail-image').hover(function () {
        var id = $(this).attr('data-id')
        $('.imagen-thumbnail-apliada').removeClass('active')
        $('#' + id).addClass('active')
    })
    $('.sourcing_and_materials').owlCarousel({
        margin: 25,
        dots: false,
        responsiveClass: true,
        loop: true,
        responsive: {
            0: {
                items: 1,
                autoplay: true
            },
            576: {
                items: 2,
                autoplay: true
            },
            768: {
                items: 3
            }
        }
    });
    $('.nav-link').hover(function () {
        if ($(this).hasClass('megaMenuDropdown')) {
            $('.megamenu').slideDown('slow')
        } else {
            $('.megamenu').slideUp('slow')
        }
    }, function () { return })
    $('.megamenu').hover(function () { return }, function () {
        $('.megamenu').slideUp('slow')
        $('.menu-transparente').removeClass('opened')
    })
    $('.menu-transparente .nav-link').hover(function () {
        if ($(this).hasClass('megaMenuDropdown')) {
            $('.menu-transparente').addClass('opened')
        } else {
            if (window.innerWidth >= 992) {
                $('.menu-transparente').removeClass('opened');
            }
        }
    })
    function showPriceRange(product) {
        let variants = product.variants || [];
        let minPrice = null;
        let maxPrice = null;
        let minCompareAtPrice = null;
        let maxCompareAtPrice = null;

        if (variants.length > 0) {
            // Extraer los precios de todas las variantes
            let prices = variants.map(variant => parseFloat(variant.price));
            let comparePrices = variants.map(variant => parseFloat(variant.compare_at_price || 0)).filter(price => price > 0);

            // Obtener el mínimo y el máximo
            minPrice = Math.min(...prices);
            maxPrice = Math.max(...prices);

            // Obtener el mínimo y el máximo de los precios rebajados (si existen)
            if (comparePrices.length > 0) {
                minCompareAtPrice = Math.min(...comparePrices);
                maxCompareAtPrice = Math.max(...comparePrices);
            }
        } else {
            // Si no hay variantes, usar el precio del producto directamente
            minPrice = parseFloat(product.price) || 0;
            maxPrice = minPrice;

            minCompareAtPrice = parseFloat(product.compare_at_price) || 0;
            maxCompareAtPrice = minCompareAtPrice;
        }

        // Formatear los precios
        let formattedMinPrice = (minPrice).toFixed(2) + ' ' + Shopify.currency.active;
        let formattedMaxPrice = (maxPrice).toFixed(2) + ' ' + Shopify.currency.active;

        let formattedMinCompareAtPrice = minCompareAtPrice ? (minCompareAtPrice).toFixed(2) + ' ' + Shopify.currency.active : null;
        let formattedMaxCompareAtPrice = maxCompareAtPrice ? (maxCompareAtPrice).toFixed(2) + ' ' + Shopify.currency.active : null;

        // Construir HTML del precio
        let priceHtml = `<p class="price">$${formattedMinPrice}</p>`;

        if (minPrice !== maxPrice) {
            priceHtml = `<p class="price">$${formattedMinPrice} - $${formattedMaxPrice}</p>`;
        }

        // Si hay un precio de comparación (rebaja)
        if (minCompareAtPrice && minCompareAtPrice > minPrice) {
            if (minCompareAtPrice !== maxCompareAtPrice) {
                priceHtml = `
                <p class="price price-sale">$${formattedMinPrice} - $${formattedMaxPrice}</p>
                <p class="price price-compare">$${formattedMinCompareAtPrice} - $${formattedMaxCompareAtPrice}</p>
            `;
            } else {
                priceHtml = `
                <p class="price price-sale">$${formattedMinPrice}</p>
                <p class="price price-compare">$${formattedMinCompareAtPrice}</p>
            `;
            }
        }
        return priceHtml;
    }
    // Función para actualizar el ID de la variante y verificar la disponibilidad
    function updateQuickShopVariant(variations, product) {
        const selectedColor = $('#colorQuickShop').val(); // Valor seleccionado de color
        const selectedSize = $('#sizeQuickShop').val(); // Valor seleccionado de talla
        variantIdInput = $('#selected-variant-id-quickshop')
        addToCartButton = $('#add-to-cart-btn-quickshop, .go-to-checkout-quickshop')
        let variant = null;

        // Si el producto tiene ambas opciones
        if (selectedColor && selectedSize) {
            $.each(variations, function (index, v) {
                let matchingVariant = product.variants.find(variant => variant.id == v.id);
                if (v.available && matchingVariant.option1 === selectedColor && matchingVariant.option2 === selectedSize) {
                    variant = matchingVariant;
                    return false; // Salir del loop
                }
            });
        }
        // Si el producto solo tiene color
        else if (selectedColor && !selectedSize) {
            $.each(variations, function (index, v) {
                let matchingVariant = product.variants.find(variant => variant.id == v.id);
                if (v.available && matchingVariant.option1 === selectedColor) {
                    variant = matchingVariant;
                    return false; // Salir del loop
                }
            });
        }
        // Si el producto solo tiene talla
        else if (!selectedColor && selectedSize) {
            $.each(variations, function (index, v) {
                let matchingVariant = product.variants.find(variant => variant.id == v.id);
                if (v.available && matchingVariant.option2 === selectedSize || v.available && matchingVariant.option1 === selectedSize) {
                    variant = matchingVariant;
                    return false; // Salir del loop
                }
            });
        }

        // Actualizar el estado del botón y el ID de variante
        if (variant) {
            variantIdInput.val(variant.id); // Actualizar el campo con el ID de la variante
            addToCartButton.prop('disabled', false); // Habilitar el botón de añadir al carrito
            addToCartButton.removeClass('disabled'); // Asegurarse de que no esté visualmente deshabilitado
            $('.aviso.QuickShop').addClass('d-none'); // Eliminar mensaje de "no disponible" si aparece
        } else {
            variantIdInput.val(''); // Vaciar el campo del ID de la variante
            addToCartButton.prop('disabled', true); // Deshabilitar el botón
            addToCartButton.addClass('disabled'); // Asegurarse de que el botón esté visualmente deshabilitado
            if (!$('.out-of-stock').length) {
                $('.aviso.QuickShop').removeClass('d-none'); // Mostrar mensaje de "no disponible"
            }
        }
    }
    function updateQuickShopProduct(product) {
        if (product.variants.length != 1) {
            return
        }
        const defaultVariant = product.variants[0];
        $('#selected-variant-id-quickshop').val(defaultVariant.id);
    }
    $('.boton-ver-producto').click(function (e) {
        e.preventDefault();
        //Colocar botones como deshabilitados
        $('#add-to-cart-btn-quickshop, .go-to-checkout-quickshop').attr('disabled', 'disabled')
        var variations = $(this).attr('data-variants-stock')
        var colorsData = $(this).data("colors");
        if (variations.length == 0) {
            $('#add-to-cart-btn-quickshop, .go-to-checkout-quickshop').removeAttr('disabled')
        }
        try {
            variations = JSON.parse(variations.replace(/&quot;/g, '"')); // Reemplazamos entidades HTML si las hubiera
        } catch (error) {
            console.error("Error parsing variations JSON:", error);
            variations = []; // Si hay error, inicializamos como un array vacío
        }
        let productUrl = $(this).data('url'); // Obtiene la URL con .json
        $('#add-to-cart-btn-quickshop').attr('data-collection', $(this).data('collection'))// Obtiene la COLLECTION

        $.getJSON(productUrl, function (data) {
            let product = data.product; // Accede a los datos del producto
            $('.colocar-imagenes-grandes').html(`<img src="${product.image.src}" alt="${product.title}" class="active imagen-producto-quickshop rounded">`)
            $('.colocar-thumbnails').html('')
            product.images.forEach((image) => {
                $('.colocar-thumbnails').append(`
                    <div class="col-4 col-sm-12 ">
                        <img
                            src="${image.src}"
                            alt="${product.title}"
                            class="rounded thumbnail-image quickshop"
                            data-id="quickshop-${image.id}"
                        >
                    </div>`
                );
                $('.colocar-imagenes-grandes').append(`
                <img
                    src="${image.src}"
                    alt="${product.title}"
                    class="rounded imagen-thumbnail-ampliada"
                    id="quickshop-${image.id}"
                >`
                );
            });
            if (product.variants.length > 1) {
                product.variants.forEach(variant => {
                    if (variant.available && variant.option1 && variant.featured_image) {
                        $('.colocar-imagenes-grandes').append(`
                            <img
                                class="variant-featured-image imagen-thumbnail-ampliada ${variant.id}"
                                src="${variant.featured_image.src}"
                                alt="${product.title} - ${variant.option1}"
                            >`
                        );
                    }
                });
            }
            // Ajustar la altura de las miniaturas después de cargar la imagen principal
            $('.imagen-producto-quickshop').on('load', function () {
                $('.columna-thumbnails-quickshop').css('max-height', $(this).innerHeight() + 'px');
            }).each(function () {
                if (this.complete) $(this).trigger('load'); // Forzar el evento 'load' si la imagen ya está cargada
            });
            //Título
            $('.quickshop-product-title').text(product.title)
            //Precio
            $('#quickShop .product-price').html(showPriceRange(product))

            //Selector de talla y color
            let variantPickerHtml = '';
            showSizeGuide = false

            product.options.forEach(option => {
                if (option.name === 'Size') {
                    showSizeGuide = true
                    variantPickerHtml += `
                <div class="row">
            `;

                    option.values.forEach(value => {
                        variantPickerHtml += `
                    <div class="col">
                        <button type="button" class="btn btn-outline-secondary w-100 button-size-atribute" data-value="${value}">
                            ${value}
                        </button>
                    </div>
                `;
                    });

                    variantPickerHtml += `</div>`;

                    variantPickerHtml += `<select name="options[${option.name}]" id="sizeQuickShop" style="display:none;">`;
                    option.values.forEach(value => {
                        variantPickerHtml += `<option value="${value}">${value}</option>`;
                    });
                    variantPickerHtml += `</select>`;
                }

                if (option.name === 'Color') {
                    variantPickerHtml += `<select name="options[${option.name}]" id="colorQuickShop" style="display:none;">`;
                    option.values.forEach(value => {
                        variantPickerHtml += `<option value="${value}">${value}</option>`;
                    });
                    variantPickerHtml += `</select>`;
                }
            });
            //mostrar o ocultar la guia de tallas
            if (showSizeGuide) {
                $('#quickShop .quickshop-size').removeClass('d-none')
            } else {
                $('#quickShop .quickshop-size').addClass('d-none')
            }

            // Agregar selector de color si el producto tiene variantes de color
            if (product.options.some(option => option.name === 'Color') && product.variants.length > 1) {
                variantPickerHtml += `
                <div class="separador my-5"></div>
                <p class="atributo">Color: <span class="value"></span></p>
                <div class="product-colors mt-3">
                    <div class="color-selector d-flex">
                `;

                let colors = new Set();

                product.variants.forEach(variant => {
                    if (variant.option1 && !colors.has(variant.option1)) {
                        colors.add(variant.option1);
                        let bgColor = variant.option1.toLowerCase();
                        // Buscar el color HEX en la lista de colores
                        let colorMatch = colorsData.find(color => color.name.toLowerCase() === variant.option1.toLowerCase());
                        if (colorMatch) {
                            bgColor = colorMatch.color;
                        }
                        //colocar imagen pattern si se encuentra disponible
                        if (colorMatch.image.length > 0) {
                            var style = 'background-image:url("' + colorMatch.image + '")'
                        } else {
                            var style = 'background-color: ' + bgColor
                        }

                        // Busca la imagen correspondiente para la variante
                        let variantImage = product.images.find(image => image.id === variant.image_id);
                        let imageSrc = variantImage ? variantImage.src : '';

                        variantPickerHtml += `
                            <div class="color-container quickShop button-color-atribute" data-variant-id="${variant.image_id}" data-color="${variant.option1}">
                                <span class="color-circle" style='${style};'></span>
                            </div>
                        `;
                    }
                });

                variantPickerHtml += `
                    </div>
                </div>
                `;
            }

            // Insertar en el contenedor `.variant-picker`
            $('#quickShop .dinamic-variations-quickshop').html(variantPickerHtml);

            //Suscribir botones de talla y color
            // Manejo de eventos de selección de color y talla
            $('#quickShop .button-size-atribute').click(function () {
                $('#quickShop .button-size-atribute').removeClass('active');
                $(this).addClass('active');
                $('#sizeQuickShop').val($(this).attr('data-value'));
                // Actualizar la variante con el nuevo tamaño seleccionado
                updateQuickShopVariant(variations, product);
            });
            $('#quickShop .button-color-atribute').hover(function () {
                $('#quickShop .button-color-atribute').removeClass('active');
                $(this).addClass('active');
                var color = $(this).attr('data-color');
                var id = $(this).attr('data-variant-id')
                $('#colorQuickShop').val(color);
                $('#quickShop .atributo .value').text(color);
                // Actualizar la variante con el nuevo color seleccionado
                updateQuickShopVariant(variations, product);
                //Mostrar imagen del color seleccionado

                if (id.length > 0) {
                    $('.imagen-thumbnail-ampliada').removeClass('active')
                    $('#quickshop-' + id).addClass('active')
                } else {
                    $('.imagen-thumbnail-ampliada').removeClass('active')
                }
            });
            updateQuickShopProduct(product)
        });
    });
    // Mostrar imagen al hacer hover en el thumbnail (delegación de eventos)
    $('.colocar-thumbnails').on('mouseenter', '.thumbnail-image.quickshop', function () {
        var id = $(this).data('id'); // Obtener el ID de la imagen
        $('.imagen-thumbnail-ampliada').removeClass('active'); // Quitar la clase activa de todas las imágenes
        $('#' + id).addClass('active'); // Agregar la clase activa a la imagen correspondiente
    });
    //Carrito para QuickShop
    $(document).on('submit', '#quickShopForm', function (e) {
        // Obtener el botón que disparó el envío del formulario
        let $submitButton = $(document.activeElement);

        e.preventDefault(); // Evitar el envío del formulario

        let variantId = $('#selected-variant-id-quickshop').val();
        let quantity = $('#quickShop [name="quantity"]').val() || 1;

        if (variantId) {
            // Verificar si el envío es al carrito o al checkout
            if ($submitButton.attr('formaction') === '/checkout') {
                addToCart(variantId, quantity, function () { window.location.href = "/checkout" }); // Llama a tu función para agregar al carrito
            } else {
                $('.quickShopCollections').append('<input type = "hidden" data-key = "' + variantId + '" data-collection="' + $submitButton.attr('data-collection') + '">').promise().done(() => {
                    addToCart(variantId, quantity, showCartModal)
                });
            }
        }
    });
    $(document).on('submit', '#product-form', function (e) {
        let $submitButton = $(document.activeElement);
        if ($submitButton.attr('formaction') === '/checkout') {
            add_to_cart_ajax('#product-form', '.go-to-checkout', function () { window.location.href = "/checkout"; })
        } else {
            add_to_cart_ajax('#product-form', '#add-to-cart-btn', showCartModal)
        }
        return false;
    })
    function addToCart(variantId, quantity, funcion) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantId,
                quantity: quantity,
            },
            dataType: 'json',
            success: function (response) {
                funcion()
            },
            error: function (xhr, status, error) {
                $('.aviso.QuickShop').removeClass('d-none')
                setTimeout(() => {
                    $('.aviso.QuickShop').addClass('d-none')
                }, 5000);
            }
        });
    }
    function showCartModal() {
        // Verificar si la ventana modal quickShop está activa y cerrarla
        var quickShopModalEl = document.getElementById('quickShop');
        var quickShopModal = bootstrap.Modal.getInstance(quickShopModalEl);

        if (quickShopModal) {
            quickShopModal.hide();
        }
        $.getJSON('/cart.js', function (cart) {
            updateCartQuickShop(cart);
            var quickShopCart = new bootstrap.Modal(document.getElementById('quickShopCart'))
            quickShopCart.show()
        });
    }

    // Función para actualizar la interfaz del carrito
    function updateCartQuickShop(cart) {
        let subtotal = 0;

        // Guardar los nombres de las colecciones antes de limpiar
        const collectionData = {};
        $('.quickShopCollections>input').each(function () {
            const key = $(this).data('key');
            const collectionName = $(this).data('collection').trim();
            collectionData[key] = collectionName;
        });

        // Obtener la URL de la imagen desde el primer elemento en el DOM
        const removeIcon = $('.remove-icon-quickShopCart').attr('src') || '';
        const selectIcon = $('.item-quantity-quickShopCart').attr('style') || '';

        // Limpiar las filas dinámicas
        $('#quickShopCart .cart-wrapper .row.product-row, #quickShopCart .cart-wrapper .separador').remove();

        // 🛑 **Si el carrito está vacío, mostrar la plantilla de carrito vacío**
        if (cart.items.length === 0) {
            $('#quickShopCart .your-cart').addClass('d-none');
            $('#quickShopCart .cart-wrapper').addClass('d-none');
            $('#quickShopCart .subtotal-container').addClass('d-none');  // Ocultar los totales
            $('#quickShopCart .cart-empty').removeClass('d-none'); // Mostrar la plantilla de carrito vacío
            return;
        } else {
            $('#quickShopCart .your-cart').removeClass('d-none');
            $('#quickShopCart .cart-wrapper').removeClass('d-none');
            $('#quickShopCart .subtotal-container').removeClass('d-none');  // Asegurar que los totales aparecen
            $('#quickShopCart .cart-empty').addClass('d-none'); // Ocultar la plantilla de carrito vacío
        }

        // Recorrer los productos y reconstruir la interfaz
        cart.items.forEach((item, index) => {
            const itemTotal = (item.quantity * item.price) / 100; // Calcular el total del artículo
            subtotal += itemTotal; // Sumar al subtotal

            // Obtener el nombre de la colección del almacenamiento
            const collectionName = collectionData[item.variant_id] || 'Sin colección';

            // Construir los atributos como una lista
            let attributesHTML = '';
            if (item.options_with_values && item.options_with_values.length > 0) {
                attributesHTML = item.options_with_values
                    .filter((option) => option.name.toLowerCase() !== 'title') // Filtrar los que no sean "title"
                    .map((option) => `${option.name}: ${option.value}`) // Crear el string solo para los que pasaron el filtro
                    .join(', ');
            }

            // Agregar la fila de producto
            $('#cart-fullQuickShopCart').append(`
          <div
              class="row product-row align-items-center"
              data-key="${item.key}"
            >
              <div class="col-5 col-sm-3">
                <img src="${item.image}" width="254" height="auto">
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col">
                    <p class="collection-name text-uppercase mb-0">${collectionName}</p>
                  </div>
                  <div class="col-auto">
                    <p class="m-0 remove-item" data-key="${item.key}">
                      <img src="${removeIcon}">
                    </p>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col">
                    <p class="mb-1 product-title">${item.product_title}</p>
                    <p class="atributes mb-0">${attributesHTML}</p>
                  </div>
                  <div class="col-auto">
                    <p class="mb-0">$${(item.price / 100).toFixed(2)}</p>
                  </div>
                </div>
                <div class="row align-items-center mt-4">
                  <div class="col-6 col-sm-4">
                    <select
                      class="item-quantity btn btn-outline-secondary w-100 text-start"
                      data-key="${item.key}"
                      style="${selectIcon}"
                    >
                    ${[...Array(10)]
                    .map(
                        (_, i) => `<option value="${i + 1}" ${item.quantity === i + 1 ? 'selected' : ''}>${i + 1}</option>`
                    )
                    .join('')}
                  </select>
                  </div>
                  <div class="col">
                    <p class="mb-0 text-end">$${itemTotal.toFixed(2)}</p>
                  </div>
                </div>
              </div>
            </div>
        `);
            // Si no es el último producto, agregar un separador
            if (index < cart.items.length - 1) {
                $('#cart-fullQuickShopCart').append(`
            <div class="separador py-4 py-sm-5">
              <hr>
            </div>
          `);
            }
        });

        // Actualizar el subtotal
        $('#quickShopCart .subtotal').text(`$${subtotal.toFixed(2)} USD`);
    }
    //Funcionalidad para el carrito en QuickShop
    $(document).on('change', '#cart-fullQuickShopCart .item-quantity', function () {
        const key = $(this).data('key');
        const quantity = $(this).val();

        // Enviar solicitud AJAX para actualizar la cantidad
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { quantity: quantity, id: key },
            dataType: 'json',
            success: function (cart) {
                updateCartQuickShop(cart);
            },
            error: function () {
                alert('Inventory not available.');
            },
        });
    });

    // Manejar la eliminación de productos
    $(document).on('click', '#cart-fullQuickShopCart .remove-item', function () {
        const key = $(this).data('key');

        // Enviar solicitud AJAX para eliminar el producto
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { quantity: 0, id: key },
            dataType: 'json',
            success: function (cart) {
                updateCartQuickShop(cart);
            },
            error: function () {
                alert('Error al eliminar el producto. Por favor, inténtalo de nuevo.');
            },
        });
    });
    //Ajustar videos en la página de productos
    if ($('.imagen-producto').length && $('video.imagen-thumbnail-apliada').length) {
        var alto_imagen = $('.imagen-producto').innerHeight()
        $('video.imagen-thumbnail-apliada').attr('style', 'max-height:' + alto_imagen + 'px')
    }
    //mejorar la posición sticky de la vista de producto individual
    $('.carma-product-page .product-details').css('top', $('.contenedor-header').innerHeight() + 30 + 'px');
    function add_to_cart_ajax(form, button, function_var) {
        let formData = $(form).serialize(); // Serializa los datos del formulario
        $(button).prop('disabled', true)
        $.post("/cart/add", formData, function () {
            // Redirigir automáticamente al checkout después de añadir al carrito
            function_var()
        }).fail(function () {
            console.error("Error al añadir al carrito.");
        });
    }
    $('.product-card .product-image').hover(function () {
        $(this).find('.second-image').addClass('active')
    }, function () {
        $(this).find('.second-image').removeClass('active')
    })
})

function createInfiniteCarousel(containerSelector, direction, duration = 50) {
    const containers = document.querySelectorAll(containerSelector); // Cambiar a querySelectorAll para manejar múltiples elementos
    if (!containers.length) {
        return;
    }

    containers.forEach((container) => {
        const slide = container.querySelector('.slide');

        if (!slide) {
            console.error('Slide not found in container');
            return;
        }

        const slideWidth = slide.offsetWidth;

        // Clonar el slide y añadirlo al contenedor
        const clone = slide.cloneNode(true);
        container.appendChild(clone);

        let position = direction === 'right' ? -slideWidth : 0;
        container.style.transform = `translateX(${position}px)`;

        function animate() {
            if (direction === 'left') {
                position -= 1;
                if (Math.abs(position) >= slideWidth) {
                    position = 0;
                }
                container.style.transform = `translateX(${position}px)`;
            } else if (direction === 'right') {
                position += 1;
                if (position >= 0) {
                    position = -slideWidth;
                }
                container.style.transform = `translateX(${position}px)`;
            }

            setTimeout(animate, duration);
        }

        animate();
    });
}
// Uso de la función con duración controlada
createInfiniteCarousel('.text-infinite-section .contenedor', 'left', 10);
createInfiniteCarousel('.about-us .texto-infinito', 'left', 10);
